export default __webpack_public_path__ + "static/jetson_background_desktop-bbbb1657374caa0bb90958d7f4b7eb2e.png";